/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserPasswordResetRequestDto } from '../../models/user-password-reset-request-dto';

export interface UserGetPasswordResetRequest$Params {

/**
 * token
 */
  token?: string;
}

export function userGetPasswordResetRequest(http: HttpClient, rootUrl: string, params?: UserGetPasswordResetRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPasswordResetRequestDto>> {
  const rb = new RequestBuilder(rootUrl, userGetPasswordResetRequest.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserPasswordResetRequestDto>;
    })
  );
}

userGetPasswordResetRequest.PATH = '/v1/User/GetPasswordResetRequest';
